import { create } from 'zustand';

type OkCancelDialogType = 'ok_cancel' | 'ok' | 'cancel' | 'ok_all_cancel';

export interface OkCancelDialogData {
  width?: number;
  title?: string;
  customTitle?: any;
  content: any;
  confirmColor?: string;
  confirmAllText?: string;
  confirmText?: string;
  cancelText?: string;
  dangerText?: string;
  type?: OkCancelDialogType;
  onConfirmAll?: () => void;
  onConfirm?: () => void;
  onCancel?: () => void;
  onClickDanger?: () => void;
}

interface OkCancelDialog {
  show?: boolean;
  data?: OkCancelDialogData;
  open: (data: OkCancelDialogData) => void;
  close: () => boolean;
}

export const useOkCancelDialog = create<OkCancelDialog>((set, get) => ({
  show: false,
  data: {} as OkCancelDialogData,
  open: (data?: OkCancelDialogData) => {
    set({ show: true, data });
  },
  close: () => {
    const isCloseExecute = !!get().show;
    set({ show: false, data: {} as OkCancelDialogData });
    return isCloseExecute;
  },
}));
